<template>
  <div class="dialog">
    <div class="card">
      <h1>{{selectedUser ? 'Edit' : 'Add'}} User</h1>

      <form :class="{ disabled: isFormDisabled }">
        <div class="input-group two-children">
          <input
            type="text"
            ref="loginId"
            v-model="user.loginId"
            placeholder="Login ID"
            :disabled="isFormDisabled"
          />
          <input
            type="text"
            v-model="user.password"
            placeholder="Password"
            :disabled="isFormDisabled"
          />
        </div>

        <div class="input-group two-children">
          <input
            type="text"
            v-model="user.securityAnswer"
            placeholder="Security Answer"
            :disabled="isFormDisabled"
          />
          <input
            type="text"
            v-model="user.environment"
            placeholder="Environment"
            :disabled="isFormDisabled"
          />
        </div>

        <div class="input-group two-children">
          <input
            type="text"
            v-model="user.notes"
            placeholder="Notes"
            :disabled="isFormDisabled"
          />
          <ToggleSwitch
            :checked.sync="user.notWorking"
            :title="'Not Working'"
            :disabled="isFormDisabled"
          />
        </div>

        <UserFilters
          :projectFilters="project.filters"
          :userFilters="user.filters"
          @updateUserFilters="updateUserFilters"
        />

        <div class="button-group primary-button-group">
          <div class="desktop-delete-button">
            <Button
              v-if="selectedUser"
              :title="'Delete User'"
              :type="'flat'"
              :colorTheme="'warning'"
              @button-click="$emit('delete-user', user)"
            />
          </div>
          <div class="action-buttons">
            <Button
              v-if="!isFormDisabled"
              :title="'Save'"
              :type="'raised'"
              :colorTheme="'primary'"
              @button-click="$emit('save-user', user)"
            />
            <Button
              v-if="isFormDisabled"
              :title="'Edit User'"
              :type="'raised'"
              :colorTheme="'primary'"
              @button-click="allowEdit"
            />
            <Button
              :title="'Cancel'"
              :type="'raised'"
              :colorTheme="'secondary'"
              @button-click="cancelForm"
            />
          </div>
        </div>

        <div class="button-group secondary-button-group" v-if="selectedUser && !isFormDisabled">
          <Button
            :title="'Delete User'"
            :type="'flat'"
            :colorTheme="'warning'"
            @button-click="$emit('delete-user', user)"
          />
        </div>
      </form>

    </div>
  </div>
</template>

<script>
import ToggleSwitch from '@/components/form-elements/ToggleSwitch.vue'
import Button from '@/components/form-elements/Button';
import UserFilters from '@/components/user/UserFilters';

export default {
  name: 'UserForm',
  props: ['selectedUser', 'disableForm'],
  components: {
    ToggleSwitch,
    Button,
    UserFilters
  },
  data() {
    if (this.selectedUser) {
      return {
        user: this.selectedUser,
        isFormDisabled: this.disableForm
      }
    } else {
      return {
        user: {
          loginId: '',
          password: '',
          securityAnswer: '',
          environment: '',
          notes: '',
          filters: [],
          notWorking: false
        },
        isFormDisabled: this.disableForm
      }
    }
  },
  computed: {
    project() {
      return this.$store.state.projects.project
    }
  },
  created() {
    if (this.selectedUser) {
      this.userBeforeEdit = JSON.parse(JSON.stringify(this.selectedUser))
    }
  },
  mounted() {
    if (!this.selectedUser) {
      this.user.projectId = this.project.id
      this.$refs.loginId.focus()
    }
  },
  methods: {
    cancelForm() {
      Object.assign(this.user, this.userBeforeEdit)
      this.$emit('hide-dialog')
    },
    allowEdit() {
      this.isFormDisabled = false;
    },
    updateUserFilters(userFilters) {
      this.user.filters = userFilters
    }
  }
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
@import '../../assets/styles/colors';
@import '../../assets/styles/mixin';
@import '../../assets/styles/input';
@import '../../assets/styles/dialog';
@import '../../assets/styles/card';
</style>



// WEBPACK FOOTER //
// src/components/user/UserForm.vue